import React, { useMemo } from "react";
import { useCurrencySelector } from "@appsinti/currency-provider";
import { formatMoney, formatMoneyMK, formatPercentage } from "@appsinti/common-utils/textFormat";
import StatsPreview from "../../../../interfaces/StatsPreview";
import ClosedSalesCash from "./sections/ClosedSalesCash";
import Container from "./sections/Container";

const Current: React.FC<{
  stats: { [key: number]: StatsPreview };
}> = ({ stats }) => {
  const { currencyEnabled, currency } = useCurrencySelector();

  const data = useMemo(() => {
    if (!stats) {
      return {
        totalSales: null,
        salesPerGuest: null,
        cashTotal: null,
        closedSales: null,
        numberOfGroups: 0,
      };
    }

    if (currencyEnabled && currency) {
      const allValidGroups = Object.values(stats).filter((group) => {
        return !!group.salesData.conversions?.[currency];
      });
      if (allValidGroups.length > 0) {
        const response = {
          totalSales: 0,
          salesPerGuest: 0,
          cashTotal: 0,
          closedSales: 0,
          numberOfGroups: allValidGroups.length,
        };
        for (const group of allValidGroups) {
          if (group.salesData.conversions?.[currency]) {
            response.totalSales +=
              group.salesData.conversions[currency].total.totalSales;
            response.salesPerGuest +=
              group.salesData.conversions[currency].total.salesPerGuest;
            response.cashTotal += group.salesData.conversions[currency].total.totalSales * (group.salesData.conversions[currency].total.cash / 100);
            response.closedSales += group.salesData.conversions[currency].total.closedSales;
          }
        }
        return response;
      }
    }

    const response = {
      totalSales: 0,
      salesPerGuest: 0,
      numberOfGroups: 0,
      cashTotal: 0,
      closedSales: 0,
    };
    for (const group of Object.values(stats)) {
      if (
        group.salesData.total.totalSales &&
        group.salesData.total.totalSales > 0
      ) {
        response.totalSales += group.salesData.total.totalSales;
        response.salesPerGuest += group.salesData.total.salesPerGuest;
        response.cashTotal += group.salesData.total.totalSales * (group.salesData.total.cash / 100);
        response.closedSales += group.salesData.total.closedSales;
        response.numberOfGroups++;
      }
    }
    return response;
  }, [stats, currencyEnabled, currency]);

  return (
    <Container>
      <ClosedSalesCash 
        totalSales={
          typeof data.totalSales === "number"
            ? formatMoneyMK(data.totalSales)
            : "N/A"
        }
        salesPerGuest={
          typeof data.salesPerGuest === "number"
            ? formatMoney(data.salesPerGuest / data.numberOfGroups)
            : "N/A"
        }
        cashPercentage={
          typeof data.cashTotal === "number" && typeof data.totalSales === "number"
            ? (data.cashTotal > 0 ? formatPercentage((data.cashTotal * 100) / data.totalSales) : "0%")
            : "N/A"} 
        closedSales={
          typeof data.closedSales === "number"
            ? formatMoneyMK(data.closedSales)
            : "N/A"
        }
      />
    </Container>
  );
};

export default Current;
